import { DiscountBadge } from "../molecules/DiscountBadge";
import { handleSmoothAnchorScroll } from "@/helpers/scrollToProductPicker";
import parse from "html-react-parser";

type HeroTwoColumnsProps = {
  tr_heading: string;
  tr_subheading: string;
  hero_image: string | null;
  tr_discount_badge: string;
  cta?: {
    show: boolean;
    label: string;
    url: string;
  };
};

export const HeroTwoColumns = ({
  tr_heading,
  tr_subheading,
  hero_image,
  tr_discount_badge,
  cta,
}: HeroTwoColumnsProps) => (
  <div className="split-layout content-wide">
    <div className="content-left">
      <DiscountBadge text={tr_discount_badge} />

      <section className="upsell-header">
        <h1 className="upsell-title">{parse(tr_heading)}</h1>
        <div className="upsell-subtitle">{parse(tr_subheading)}</div>
      </section>

      {hero_image && (
        <div className="product-image-container mobile-only">
          <img src={hero_image} alt="" className="product-image" />
        </div>
      )}

      {cta?.show && (
        <div className="cta-section cta-left">
          <a
            href={cta.url}
            className="pay-btn add-to-order-btn"
            onClick={(e) => handleSmoothAnchorScroll(e)}
          >
            {cta.label}
          </a>
        </div>
      )}
    </div>

    {hero_image && (
      <div className="content-right desktop-only">
        <div className="product-image-container">
          <img src={hero_image} alt="" className="product-image" />
        </div>
      </div>
    )}
  </div>
);
